import { useContext } from "react";

import { NonprofitAdminPageContext } from "src/context/NonprofitAdminPageContext";
import {
  AdminSidebarContextType,
  DonationFlowCustomizationContextType,
} from "src/context/NonprofitAdminPageContext/types";

export const useAdminSidebar = (): AdminSidebarContextType => {
  const { sidebar } = useContext(NonprofitAdminPageContext);
  return sidebar;
};

export const useDonationFormCustomization =
  (): DonationFlowCustomizationContextType => {
    const { donationFlowCustomization } = useContext(NonprofitAdminPageContext);
    return donationFlowCustomization;
  };
